export default "__VITE_ASSET__DnXpsYyQ__"